import { Epic, ofType } from "redux-observable";
import { RootState } from "../../store";
import * as authSelectors from "../auth/authSelectors";
import * as beaconActions from "./beaconActions";
import { ServiceContainer } from "../../serviceContainer";
import { of } from "rxjs";
import { catchError, exhaustMap, map } from "rxjs/operators";

export const beaconsForOrganization: Epic<
  any,
  any,
  RootState,
  ServiceContainer
> = (action$, state$, services) =>
  action$.pipe(
    ofType(beaconActions.GET_BEACONS_FOR_ORGANIZATION),
    exhaustMap((action: beaconActions.GetBeaconsForOrganizationAction) => {
      const state = state$.value;

      return services.apiBeacon
        .listByOrganization(
          authSelectors.accessToken(state),
          action.organizationKeyName,
          action.filters,
          action.page
        )
        .pipe(
          map((x) =>
            beaconActions.getBeaconsForOrganizationSuccessAction(
              action.organizationKeyName,
              x.registerBeaconRequestLog
            )
          ),
          catchError(() => {
            services.toastr.error(
              "Fail",
              "There was error while fetching beacons"
            );
            return of(
              beaconActions.getBeaconsForOrganizationFailAction(
                action.organizationKeyName
              )
            );
          })
        );
    })
  );
